import appleWatches from '../../assets/bannerAd3.jpg';
import appleWatches2 from '../../assets/bannerAd2.png';
import bombasShocks from '../../assets/bannerAd1.gif';
import sale from '../../assets/sale1.gif';
import cyclingAd from '../../assets/bannerAd3.gif';
import longAd from '../../assets/longAd.png';
import longAd1 from '../../assets/longAd1.png';
import longAd3 from '../../assets/longAd3.png';
import longAd4 from '../../assets/longAd4.png';
import longAd5 from '../../assets/longAd5.png';
import longAd6 from '../../assets/longAd6.png';

export const departmentsList = {
  Beauty: ['Men\'s Grooming', 'Fragrances', 'Hair Care', 'Makeup', 'Skin Care', 'Body Care'],
  'Computers & Electronics': ['Desktop', 'Monitors', 'Computer Accessories', 'Laptop', 'Laptop Accessories', 'Software', 'Photography', 'Drones'],
  Gadgets: ['Smartphones', 'Tablets', 'Smartwatches', 'Smart Accessories'],
  Fashion: ['Men', 'Women', 'Kids', 'Watches', 'Jewellery', 'Footwear', 'Backpacks'],
  Gaming: ['Gaming Accessories', 'Playstation', 'Nintendo', 'Xbox Series'],
  'TV, Audio & Media': ['TV\'s', 'Home Entertainment', 'Headsets', 'Microphones', 'Guitars', 'Keyboard & Piano'],
  'Home & Appliances': ['Appliances', 'Kitchen', 'Furniture & Decor', 'Bed & Bath'],
  Sports: ['Sports Clothing', 'Sports Footwear', 'Sports Wearable Tech', 'Sports Nutrition', 'Cycling', 'Gym Equipment'],
};

const advertsData = [
  {
    image: appleWatches,
    url: 'https://www.apple.com/shop/buy-watch/apple-watch',
  },
  {
    image: bombasShocks,
    url: 'https://bombas.com/',
  },
  {
    image: appleWatches2,
    url: 'https://www.apple.com/shop/buy-watch/apple-watch',
  },
  {
    image: cyclingAd,
    url: '',
  },
  {
    image: sale,
    url: '',
  },
];

export const longAdverts = [
  {
    image: longAd,
    url: '',
  },
  {
    image: longAd1,
    url: '',
  },
  {
    image: longAd3,
    url: '',
  },
  {
    image: longAd4,
    url: '',
  },
  {
    image: longAd5,
    url: '',
  },
  {
    image: longAd6,
    url: '',
  },
];

export default advertsData;
